import TEButton from './TEButton'

export default TEButton
